module.exports = __webpack_public_path__ + "media/country_flags/sm-f0a89124.png";